import React from 'react';
import ResetPasswordForm from './ResetPasswordForm';

const ForgotPassword = (props) => (
  <div className="account account--not-photo">
    <div className="account__wrapper">
      <div className="account__card">
        <div className="account__head">
          <p className="topbar__logo mx-auto" style={{ height: '55px' }} />
        </div>
        <h4 className="account__subhead subhead text-center mb-4">Reset Password</h4>
        <ResetPasswordForm form="log_in_form" />
      </div>
    </div>
  </div>
);

export default ForgotPassword;
